const isDevelopment = import.meta.env.DEV;

export const API_CONFIG = {
  BASE_URL: isDevelopment 
    ? 'https://5f89602e7f02.ngrok.app'
    : 'https://api.learnplace.ai',
  
  ENDPOINTS: {
    PUBLIC_PORTFOLIO: '/v1/portfolio/public',
  }
}

export async function fetchPublicPortfolio(uniqueId: string) {
  const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PUBLIC_PORTFOLIO}/${uniqueId}`)
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Portfolio not found')
    }
    if (response.status === 403) {
      throw new Error('This portfolio is private')
    }
    throw new Error('Failed to load portfolio')
  }
  
  return response.json()
}
